<template>

    <div>
        <div v-bind:class="ContentBlockBaseProps.Class" v-bind:style="ContentBlockBaseProps.Style">
            <div :class="BlockProps.Shadow? 'shadow-sm mb-3' : ''" :style="{'background-color' : BlockProps.BGColor + ' !important'}">
                <div class="container position-relative" v-bind:style="ContainerPadding">

                    <div class="container">
                        <div class="row justify-content-md-center">

                            <div class="col-lg-10">
                                <div class="card text-center shadow-sm">

                                    <div  class="card-body" style="padding-bottom:0; padding-left: 0; padding-right:0; padding-top:0px;min-height:400px">

                                        <div class="text-center py-3">
                                            <button type="button" class="btn btn-sm btn-danger px-2" style="padding:2px;" @click="OnResetCart">
                                                <i class="bi bi-trash"></i> Empty Cart &amp; Start Over
                                            </button>
                                        </div>

                                        <form-wizard style="height:100%" :disableBackOnClickStep="true" @onChange="WizOnChangeStep" ref="TheWiz" color="rgba(10,191,83,.5)" step-size="sm" shape="round" finish-button-text="Pay Now">

                                            <!--Service Selection-->
                                            <tab-content title="Service" icon="bi bi-cart-check">
                                                <CheckoutServicePicker></CheckoutServicePicker>
                                            </tab-content>
                                            <!--End Service Selection-->

                                            <tab-content title="Venue" icon="bi bi-geo-alt" style="">
                                                <component class="shadow-sm" :is="VenueSelectComponent" v-if="Store.Checkout.Cart.CurrentStep == 1"></component>
                                            </tab-content>

                                            <tab-content title="Schedule" icon="bi bi-calendar-date">
                                                <component class="shadow-sm" :is="SchedulerComponent" v-if="Store.Checkout.Cart.CurrentStep == 2"></component>
                                            </tab-content>

                                            <tab-content title="Pay" icon="bi bi-credit-card">
                                                <component class="shadow-sm" :is="PaymentComponent" v-if="Store.Checkout.Cart.CurrentStep == 3"></component>                                                
                                            </tab-content>

                                            <template v-slot:footer="props">
                                                <div class="wizard-footer-left">
                                                    <button style="border-bottom-right-radius:0; border-top-right-radius: 0;border-top-left-radius: 0; border-bottom-left-radius: 0.8125rem " class="btn btn-sm btn-soft-primary" v-if="props.activeTabIndex > 0" @click.native="OnWizCmdPrev()">Previous</button>
                                                </div>
                                                <div class="wizard-footer-right">
                                                    <button :disable="!Store.Checkout.NextButton.CanGoNext" style="border-bottom-right-radius: 0.8125rem; border-top-right-radius: 0; border-top-left-radius: 0; border-bottom-left-radius: 0" v-if="!props.isLastStep && Store.Checkout.NextButton.IsVisible" @click.native="OnWizCmdNext" class="wizard-footer-right btn btn-sm btn-primary"><i class="bi" :class="Store.Checkout.NextButton.Icon"></i> {{Store.Checkout.NextButton.Text}}</button>
                                                </div>
                                            </template>
                                            <!--<div class="text-muted" style="margin-top:0px;margin-bottom:30px">
                                                {{StepInstruction}}
                                            </div>-->

                                        </form-wizard>
                                        <div class="overlay" id="loading" v-if="Loading">
                                            <div class="d-flex justify-content-center align-items-center" style="height:100%">
                                                <div class="spinner-border text-primary" role="status">
                                                </div>
                                                <br />
                                            </div>
                                        </div>
                                    </div>

                                </div>


                            </div>

                        </div>

                    </div>

                </div>
            </div>
        </div>

        <div v-if="iseditmode" style="z-index:300" class="modal" :id="'editor' + BlockProps.UId" tabindex="-1" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
            <div class="modal-dialog modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Options</h5>
                    </div>
                    <div class="modal-body">
                        <hr style="margin: 0px; margin-bottom:10px;" />
                        <propertybaseeditors :hidefeaturetie="true" :blockprops="BlockProps" :additionalcfg="AdditionalCfg"></propertybaseeditors>
                        <propertytogglededitor propertyname="ShowFlourish" :blockprops="BlockProps" prompt="Show Decorative Flourish"></propertytogglededitor>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-sm btn-secondary" data-bs-dismiss="modal">Done</button>
                        <!--<button type="button" class="btn btn-sm btn-primary">Save changes</button>-->
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>    
    import EventHub from '/src/Util/EventHub.js';
    import ContentBlockBase from '/src/components/ContentCreator/ContentBlockBase.vue'
    import { computed, ref, nextTick } from 'vue'
    import { toast } from 'vue3-toastify';
    import axios from '/src/components/NovaAxios.js';

    import CheckoutPayment from '/src/components/ContentCreator/Functional/CheckoutPayment.vue';
    import CheckoutScheduler from '/src/components/ContentCreator/Functional/CheckoutScheduler.vue';
    import CheckoutVenueSelect from '/src/components/ContentCreator/Functional/CheckoutVenueSelect.vue';
    import CheckoutServicePicker from '/src/components/ContentCreator/Functional/CheckoutServicePicker.vue';
  
    import { FormWizard, TabContent, WizardButton } from 'vue3-form-wizard'

    import 'vue3-form-wizard/dist/style.css'
    import { useEditorStore } from '/src/stores/EditorStore';

    export default {
        inheritAttrs: false,
        name: 'Checkout',
        mixins: [ContentBlockBase],
        props: ['notaryconfig', 'apostilleconfig', 'courierconfig', 'fieldinspectionconfig'],
        components: {
            FormWizard,
            TabContent,
            CheckoutVenueSelect,
            CheckoutScheduler,
            CheckoutPayment,
            CheckoutServicePicker,
         
        },
        computed:
        {      
            VenueSelectComponent: function () {
                return CheckoutVenueSelect;
            },
            SchedulerComponent: function () {
                return CheckoutScheduler;
            },
            PaymentComponent: function () {
                return CheckoutPayment;
            },
            StepInstruction:function(){
                switch(this.Store.Checkout.Cart.CurrentStep){
                    case 0:
                        return "Select the service you want to order.";
                        break;
                    case 1:
                        return "Service Venue";
                        break;
                    case 2:
                        return "Select An Appointment Time.";
                        break;
                    case 3:
                        return "Payment Information.";
                        break;
                }
                return "";
            },
            TenantConfig: function () {
                var x = this.Store.TenantConfig;
                if (this.tenantconfig) {
                    return this.tenantconfig
                }

                if (this.Store && this.Store.TenantConfig && this.Store.TenantConfig) {
                    return this.Store.TenantConfig;
                }
            },
            FieldInspectionConfig: function () {
                var x = this.Store.TenantConfig;
                if (this.fieldinspectionconfig) {
                    return this.fieldinspectionconfig
                }

                if (this.Store && this.Store.TenantConfig && this.Store.TenantConfig.serviceConfigFieldInspection) {
                    return this.Store.TenantConfig.serviceConfigFieldInspection;
                }
            },
            CourierConfig: function () {
                var x = this.Store.TenantConfig;
                if (this.courierconfig) {
                    return this.courierconfig
                }

                if (this.Store && this.Store.TenantConfig && this.Store.TenantConfig.serviceConfigCourier) {
                    return this.Store.TenantConfig.serviceConfigCourier;
                }
            },
            ApostilleConfig: function () {
                var x = this.Store.TenantConfig;
                if (this.apostilleconfig) {
                    return this.apostilleconfig
                }

                if (this.Store && this.Store.TenantConfig && this.Store.TenantConfig.serviceConfigApostille) {
                    return this.Store.TenantConfig.serviceConfigApostille;
                }
            },
            NotaryConfig: function () {
                var x = this.Store.TenantConfig;
                if (this.notaryconfig) {
                    return this.notaryconfig
                }

                if (this.Store && this.Store.TenantConfig && this.Store.TenantConfig.serviceConfigNotary) {
                    return this.Store.TenantConfig.serviceConfigNotary;
                }
            },
            MobileNotaryConfig: function () {
                var x = this.Store.TenantConfig;
                if (this.notaryconfig) {
                    return this.notaryconfig
                }

                if (this.Store && this.Store.TenantConfig && this.Store.TenantConfig.serviceConfigMobileNotary) {
                    return this.Store.TenantConfig.serviceConfigMobileNotary;
                }
            }
        },
        watch: {
            'Store.Checkout.Cart.CurrentStep': function (newVal, oldVal) {
                //this.Store.Checkout.Cart.CurrentStep = newVal;
                //switch (this.Store.Checkout.Cart.CurrentStep) {
                //    case 1:
                //        if (this.Store.Checkout.Cart.SelectedService == "RONNotarization") {
                //            this.Store.Checkout.NextButton.IsVisible = false;
                //        }
                //        else {
                //            this.Store.Checkout.NextButton.IsVisible = true;
                //        }
                //        break;
                //    case 0:
                //    case 2:
                //        if (this.Store.Checkout.Cart.SelectedService != "Apostille") {
                //            this.Store.Checkout.NextButton.IsVisible = false;
                //        }                        
                //        break;
                //    default:
                //        this.Store.Checkout.NextButton.IsVisible = true;
                //        break;
                //}
            },
        },
        data() {
            return {  
                
                Store: null,
              
                PayButtonText: 'Pay Now',
                AvailableServices: [],
  
                Loaded: false,
          
                Loading: false,
                AdditionalCfg: 'https://admin.notarylaunchpad.com/home/sitesettings'
            };
        },
        methods:
        {      
            WizOnLoading: function (isIt) {
                this.Loading = isIt;
            },

            OnWizCmdNext: function () {
                EventHub.$emit("OnCmdNext");
            },

            OnWizCmdPrev: function () {
                this.Store.SetCurrentStep((this.Store.Checkout.Cart.CurrentStep || 0) - 1)
            },
            OnResetCart: function () {
                if (this.Store && typeof this.Store.EmptyCartAndRestart === 'function') {
                    this.Store.EmptyCartAndRestart();
                }
            },

            EventHubGoPrevTab: function () {
                try {
                    this.$refs.TheWiz.prevTab();
                } catch (e) {

                }
            },

            EventHubGoNextTab: function () {  
                try {
                    this.$refs.TheWiz.nextTab();
                } catch (e) {

                }
            },

            EventHubGoTab: function (oldIndex, newIndex) {
                try {
                    this.$refs.TheWiz.changeTab(oldIndex, newIndex)
                    nextTick().then(() => EventHub.$emit('OnStepActivated'));
                } catch (e) {
                }
            },
           
            WizOnChangeStep: function (oldIdx, newIdx) {
                //this.Store.SetCurrentStep(newIdx);                
            },
      
            EditProperties: function () {
                var id = '#editor' + this.BlockProps.UId;
                var modalEl = document.querySelector(id);
                if (modalEl == null) {
                    return;
                }
                var modal = bootstrap.Modal.getOrCreateInstance(modalEl); // Returns a Bootstrap modal instance
                modal.show();
            },

            RefreshTenantConfig: function () {
                var that = this;
                var token = document.querySelectorAll('input[name=__RequestVerificationToken]')[0].value;
                // Fetch fresh tenant config directly from DB (no server-side output cache)
                axios.postForm('/API/GetFreshTenantConfig', {}, {
                    cache: false,
                    headers: {
                        'RequestVerificationToken': token
                    }
                }).then(function (response) {
                    if (response.data.success && response.data.tenantConfig) {
                        that.Store.updateTenantConfig(response.data.tenantConfig);
                    }
                }).catch(function () {
                    // Non-critical - worst case, the existing cached config is used.
                    // Server-side validation will catch any pricing mismatch at checkout.
                });
            },
            GetCart: function () {
                var that = this;

                var token = document.querySelectorAll('input[name=__RequestVerificationToken]')[0].value;
                EventHub.$emit("PageLoading", true);
                axios.postForm('/API/GetCart', {
                }, {
                    cache: false,
                    headers: {
                        'RequestVerificationToken': token
                    }
                }).then(function (response) {
                    EventHub.$emit("PageLoading", false);
                    if (response.data.success) {
                        that.Store.Checkout.Cart = response.data.cart;

                        // For courier orders, reset pricing so user must re-validate with fresh tenant settings
                        if (that.Store.Checkout.Cart.SelectedService === 'CourierDelivery' && that.Store.Checkout.Cart.DeliveryItemInfo) {
                            that.Store.Checkout.Cart.DeliveryItemInfo.forEach(function (item) {
                                item.Valid = false;
                                item.Cost = 0;
                                item.CostExpress = 0;
                                item.Error = '';
                            });
                            that.Store.Checkout.Cart.CourierPickupFee = 0;
                            that.Store.Checkout.Cart.Price = 0;

                            // Regress to venue step so user re-validates
                            if (that.Store.Checkout.Cart.CurrentStep > 1) {
                                that.Store.Checkout.Cart.CurrentStep = 1;
                            }
                        }

                        that.Store.SetCurrentStep(that.Store.Checkout.Cart.CurrentStep || 0);

                        // Emit event that cart is loaded
                        EventHub.$emit("CartLoaded", that.Store.Checkout.Cart);
                    }
                    else {
                        toast.error("There was an retrieving your cart. Please refresh the page and try again. " + response.data.msg);
                    }
                }).catch(function (error) {
                    EventHub.$emit("PageLoading", false);
                    toast.error("There was an error. Please refresh the page and try again. " + (error ? error : ""));
                });
            },
          
        },

        setup(props, context)
        {             
            return {} // anything returned here will be available for the rest of the component
        },
        created()
        {               
            this.Store = useEditorStore();            
           
            nextTick().then(() => {

            });
            
            EventHub.$on('GoPrevTab', this.EventHubGoPrevTab);
            EventHub.$on('GoNextTab', this.EventHubGoNextTab);
            EventHub.$on('WizLoading', this.WizOnLoading);
            EventHub.$on('GoTab', this.EventHubGoTab);
            
        },      
        beforeUnmount() {
            EventHub.$off('GoTab', this.EventHubGoTab);
            EventHub.$off('GoPrevTab', this.EventHubGoPrevTab);
            EventHub.$off('WizLoading', this.WizOnLoading);
            EventHub.$off('GoNextTab', this.EventHubGoNextTab);
        },
        beforeDestroy() {
        },
       
        mounted() {
            this.Store.Checkout.Cart.CurrentStep = 0;
            this.RefreshTenantConfig();
            this.GetCart();
        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

    .overlay{
        z-index:9;
    }
    .wizard-card-footer {
        border-top: 1px solid rgba(10,191,83,0.1);
        background-color: rgba(10,191,83,0.1);
        border-top-left-radius: 0 !important;
        border-top-right-radius: 0 !important;
        border-bottom-right-radius: 0.8125rem !important;
        border-bottom-left-radius: 0.8125rem !important;
    }
    .vue-form-wizard .wizard-card-footer {
        padding: 0;
    }

    .vue-form-wizard {
        padding-bottom: 0px !important;
    }

    .wizard-tab-content {
        padding-top: 0 !important;
        padding-left: 12px !important;
        padding-right: 12px !important;
        padding-bottom: 1px !important;
    }


    .card {
        position: relative;
    }

    .overlay {
        background-color:white;
        position: absolute;
        width: 100%;
        height:100%;
        top: 0;
        left: 0;
        opacity: 0.9;
        
    }

    .card-transition:hover {
        background-color: rgba(10,191,83,.075) !important;
        border-color: forestgreen;
    }
    .card-title{
        margin-bottom: 0 !important;
    }

    .wizard-nav.wizard-nav-pills {
        border-bottom: 1px solid lightgray !important;
        padding-bottom: 15px;
    }

    .stepTitle {
        color: darkgray !important;
    }

    .stepTitle.active {
        color: black !important;
    }
    .wizard-btn{
        color: black !important;
    }
    /* Style the .contact-content div */
    .contact-content {
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        position: relative;
        z-index: 1;
    }

    .contact-content::before {
        content: "";
        display: block;
        position: absolute;
        z-index: -1;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background: rgba(0,0,0,.7);
    }
    
        /* Style the content inside .contact-content */
        .contact-content .row {
            color: #fff; 
        }

        /* Style the content divs inside .contact-content */
        .contact-content .col-1 {
            /* Add your styling for the icon column */
        }

        .contact-content .col-11 {
            /* Add your styling for the address column */
        }
</style>

